import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(4.125),
    textAlign: 'left',
  },
  agreementContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1),
    fontSize: '0.875rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  agreementTitle: {
    fontWeight: 600,
  },
  agreementFiles: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  agreementType: {
    textTransform: 'uppercase',
    marginTop: theme.spacing(1.75),
    marginBottom: theme.spacing(1.75),
  },
  agreementFile: {
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    border: '1px solid #C9D2DC',
    borderRadius: '4px',
    minWidth: '200px',
    background: '#fff',
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    padding: theme.spacing(2, 1.75),
    marginBottom: theme.spacing(1),
    '&:last-of-type': {
      marginRight: 0,
    },
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  pdfIcon: {
    marginRight: theme.spacing(2),
  },
}))
